import {
    AreaNotificationMessage,
    AuthenticatedUser,
    getUserFromStorage,
    useRelodeApp,
} from "@relode/core";
import { UserRole } from "@relode/core/domain";
import * as React from "react";

import { MarketResearchMarketing } from "../../shared/components";
import { ClientMarketResearchContainer } from "./clientMarketResearchContainer";

export const ClientMarketResearchFeature = () => {
    const {
        state: { teamPlanFeatures },
    } = useRelodeApp();
    const user: AuthenticatedUser | null = getUserFromStorage();

    if (typeof teamPlanFeatures?.marketResearchAnytimeEnabled === "undefined")
        return null;

    if (user.role.roleId !== UserRole.ClientAdmin.roleId) {
        return (
            <AreaNotificationMessage level="error">
                You do not have access to the market research feature.
            </AreaNotificationMessage>
        );
    }

    return teamPlanFeatures?.marketResearchAnytimeEnabled ? (
        <ClientMarketResearchContainer />
    ) : (
        <MarketResearchMarketing
            jobManagerEmail={teamPlanFeatures?.jobManagerEmail}
            jobManagerName={teamPlanFeatures?.jobManagerName}
            jobManagerPhoneNumber={teamPlanFeatures?.jobManagerPhoneNumber}
        />
    );
};
